// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ab-3";
export var contentContainer = "_ab-0";
export var editorContainer = "_ab-1";
export var quillInputForm = "_ab-2";
export var zoneDivider = "_ab-4";